"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _unset2 = _interopRequireDefault(require("lodash/unset"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var PATH = 'xdm.web.webInteraction';
var fields = ['name', 'type', 'URL'];
var getFieldPath = function getFieldPath(field) {
  return [PATH, field].join('.');
};
var cleanWebInteraction = function cleanWebInteraction(event) {
  fields.forEach(function (field) {
    (0, _unset2["default"])(event, getFieldPath(field));
  });
  return event;
};
var _default = exports["default"] = cleanWebInteraction;